export function DateDifference(mydate) {
  var currentTime = new Date();
  var month = currentTime.getMonth() + 1;
  var day = currentTime.getDate();
  var year = currentTime.getFullYear();
  var today = year + "/" + month + "/" + day;

  var d1 = new Date(mydate);
  var d2 = new Date(today);
  var df = d1 - d2;
  var dfDay = Math.round(df / 24 / 60 / 60 / 1000);
  return dfDay;
}
